import { ColaFileTab } from './ColaFileTab'
import { connect } from 'react-redux'

const mapStateToProps = (state: { activeBot }) => ({
  activeBot: state.activeBot,
})

export default connect(mapStateToProps)(ColaFileTab)
